import { MapPin, TrendingUp, Shield, Clock, Users, Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { popularLocations } from "@/data/locations";
import { useLanguage } from "@/hooks/use-language";

export function StatsSection() {
  const { t } = useLanguage();

  const stats = [
    { icon: Users, value: "15,000+", label: t.stats.verifiedProfessionals },
    { icon: Star, value: "4.8", label: t.stats.averageRating },
    { icon: Clock, value: "< 2hrs", label: t.stats.averageResponse },
    { icon: Shield, value: "100%", label: t.stats.verifiedProfiles },
  ];

  return (
    <section className="bg-primary py-12 md:py-16">
      <div className="container px-4">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <stat.icon className="mx-auto mb-3 h-8 w-8 text-white" />
              <div className="mb-1 font-display text-3xl font-extrabold text-white drop-shadow-sm md:text-4xl">
                {stat.value}
              </div>
              <div className="text-sm font-medium text-white">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function PopularLocations() {
  const { t } = useLanguage();

  return (
    <section className="bg-background py-16 md:py-20">
      <div className="container px-4">
        {/* Section Header */}
        <div className="mb-12 text-center">
          <Badge variant="secondary" className="mb-4">
            <TrendingUp className="mr-1 h-3 w-3" />
            {t.home.popularLocations}
          </Badge>
          <h2 className="mb-4 font-display text-3xl font-extrabold tracking-tight text-foreground md:text-4xl">
            {t.home.findProsNearYou}
          </h2>
          <p className="mx-auto max-w-2xl text-muted-foreground font-medium leading-relaxed">
            {t.home.popularLocationsDesc}
          </p>
        </div>

        {/* Location Cards */}
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {popularLocations.map((location) => (
            <div
              key={`${location.state}-${location.area}`}
              className="group cursor-pointer rounded-xl bg-card p-4 shadow-card transition-all hover:-translate-y-1 hover:shadow-soft border border-border/50"
            >
              <div className="mb-2 flex items-center gap-2">
                <MapPin className="h-4 w-4 text-primary" />
                <span className="font-bold text-foreground">
                  {location.area}
                </span>
              </div>
              <p className="mb-2 text-xs font-medium text-muted-foreground">
                {location.state}
              </p>
              <p className="text-sm font-semibold text-primary">
                {location.count.toLocaleString()} {t.common.providers.toLowerCase()}
              </p>
            </div>
          ))}
        </div>

        {/* View All */}
        <div className="mt-8 text-center">
          <a
            href="#"
            className="text-sm font-medium text-primary hover:underline"
          >
            {t.home.viewAllLocations} →
          </a>
        </div>
      </div>
    </section>
  );
}
